<template>
    <b-tab title="ข้อมูลรถ">
        <b-row>
            <b-col lg="12" class="my-2">
                <h4 class="text-muted">ข้อมูลรถ</h4>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ประเภทรถ">
                    <multiselect
                        v-model="driverDetails.vehicle.vehicleCategory"
                        deselect-label="Can't remove this value"
                        track-by="id"
                        label="name"
                        placeholder="ค้นหาประเภทรถ"
                        :options="LIST_TYPE_CAR"
                        :allow-empty="false"
                        disabled
                    ></multiselect>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ทะเบียนรถ">
                    <b-form-input 
                        v-model="driverDetails.vehicle.plate"
                        disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="จังหวัด">
                    <b-form-input 
                        v-model="driverDetails.vehicle.province"
                        disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ยี่ห้อ">
                    <b-form-input 
                        v-model="driverDetails.vehicle.brand"
                        disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ปีที่ผลิต">
                    <b-form-input 
                        v-model="driverDetails.vehicle.year_created"
                        disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ชนิดเครื่องยนตร์">
                    <b-form-input
                        v-model="driverDetails.vehicle.engine_type"
                        disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ขนาดเครื่องยนตร์">
                    <b-form-input
                        v-model="driverDetails.vehicle.engine_size"
                        disabled
                    ></b-form-input>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group label="ระบบขับเคลื่อน">
                    <b-form-input
                        v-model="driverDetails.vehicle.drive_system"
                        disabled
                      ></b-form-input>
                </b-form-group>
            </b-col>
        </b-row>
    </b-tab>
</template>

<script>
import vehicleTypeService from "@/api/vehicle-type.service.js"
export default {
    props:{
        driverDetails: {
            type: Object
        }
    },
    data() {
        return { 
            LIST_TYPE_CAR : []
        }
    },
    async mounted(){
        await this.getCategory();
    },
    methods: {
        async getCategory (){
            const { data } = await vehicleTypeService.getVehicleCategory()
            this.LIST_TYPE_CAR = data.data
        },
    }
}
</script>
